// src/config/domain.js
// ─────────────────────────────────────────────────────────────
// ЄДИНЕ МІСЦЕ для домену backend/сайту та fallback-назви бренду.
//
// Справжнє джерело правди — файл /src/domain.config.json.
// Щоб перейти з bonvoyagewh.com на cropiva.ca — зміни ЛИШЕ значення
// SITE_DOMAIN у /src/domain.config.json (один раз, в одному місці).
//
// BRAND_NAME тут — це лише FALLBACK (використовується, поки
// sheet-settings.json ще не завантажився, або якщо адмін не задав
// "Brand Name" у налаштуваннях). Основне джерело назви бренду —
// адмінка → Settings → "Brand Name", яка пише у sheet-settings.json
// і читається через window._bvS.brandName. Компоненти мають писати:
//   window._bvS?.brandName || BRAND_NAME
//
// (Файл лежить саме в src/, бо CRA/react-scripts забороняє імпорт
// файлів поза src/ — ModuleScopePlugin — інакше ламається build.)
//
// Той самий domain.config.json читає й scripts/generate-domain-files.js,
// який перед `npm start` / `npm run build` сам прописує актуальний домен
// і fallback-назву бренду у статичні файли, що рендеряться ДО завантаження
// JS і тому не можуть прочитати window._bvS:
//   public/index.html, public/sitemap.xml, public/robots.txt,
//   .well-known/security.txt, vercel.json, public/manifest.json,
//   public/site.webmanifest, public/ads.txt
//
// Усі інші файли (api.js, компоненти, лендинги, admin) імпортують
// SITE_DOMAIN / SITE_URL / BRAND_NAME звідси і НЕ повинні містити
// домен чи назву бренду захардкодженими.
// ─────────────────────────────────────────────────────────────

import domainConfig from '../domain.config.json';

export const SITE_DOMAIN   = domainConfig.SITE_DOMAIN;
export const FRONTEND_HOST = domainConfig.FRONTEND_HOST;
export const BRAND_NAME    = domainConfig.BRAND_NAME;
export const CONTACT_EMAIL = domainConfig.CONTACT_EMAIL;
export const CONTACT_PHONE = domainConfig.CONTACT_PHONE;
export const INSTAGRAM_HANDLE = domainConfig.INSTAGRAM_HANDLE;
export const INSTAGRAM_URL    = `https://instagram.com/${INSTAGRAM_HANDLE}`;

export const SITE_URL     = `https://${SITE_DOMAIN}`;
export const FRONTEND_URL = `https://${FRONTEND_HOST}`;

// Похідні шорткати, якими часто користується код проєкту
export const LOGO_BASE   = `${SITE_URL}/logos`;
export const LOGO_URL    = `${LOGO_BASE}/logo.webp`;
export const LOGO_SM_URL = `${LOGO_BASE}/logo-sm.webp`;
export const ITEMS_JSON_URL    = `${SITE_URL}/items.json`;
export const SETTINGS_JSON_URL = `${SITE_URL}/sheet-settings.json`;
